/* eslint-disable @typescript-eslint/indent */
import React from 'react';
import styled, { css } from 'styled-components';
import { colors, typography } from '../../../styles/theme';

export type Props = {
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  color?:
    | 'default'
    | 'primary'
    | 'accent'
    | 'black'
    | 'black90'
    | 'black80'
    | 'black70'
    | 'black50'
    | 'black24'
    | 'red'
    | 'white';
  scale?: 'body1' | 'caption1' | 'caption2' | 'subtitle2' | 'heading4' | 'heading5' | 'heading6';
  weight?: 'light' | 'regular' | 'medium' | 'semibold' | 'bold' | 'inherit';
  marginTop?: number;
} & React.AllHTMLAttributes<Element>;

const mapColor = {
  accent: 'accent.base',
  default: 'default.base',
  black: 'black.base',
  black90: 'black.90',
  black80: 'black.80',
  black70: 'black.70',
  black50: 'black.50',
  black24: 'black.24',
  primary: 'primary.base',
  red: 'red.base',
  white: 'white.base',
};

const Strong = styled.strong<Props>`
  text-align: ${({ align }) => align};
  color: ${({ color = 'black' }) => colors(mapColor[color!])};
  font-weight: ${typography('weights.bold')};

  ${({ scale }) => css`
    font-size: ${typography(`${scale}.fontSize`)};
    line-height: ${typography(`${scale}.lineHeight`)};
    letter-spacing: ${typography(`${scale}.letterSpacing`)};
  `}

  ${({ marginTop }) => css`
    margin-top: ${marginTop}px;
  `}
`;

Strong.defaultProps = {
  align: 'inherit',
  color: 'default',
  scale: 'body1',
  marginTop: 0,
};

export default Strong;
